import { z } from 'zod';

import {
  EMPTY_FIELD_MESSAGE,
  validateEditorEn,
  validateSpace,
  validateSpaceTextInput,
  validateTextEn,
} from '@Utils/validation';

enum OVERVIEW_MESSAGE {
  INTRODUCTION_EN = 'กรุณาระบุคำบรรยายแผนการเพิ่มมูลค่าองค์กร และการบริหารความเสี่ยงเป็นภาษาอังกฤษ',
  REMARK_EN = 'กรุณาระบุหมายเหตุแผนการเพิ่มมูลค่าองค์กร และการบริหารความเสี่ยงเป็นภาษาอังกฤษ',
}

export const OverviewSchema = z.object({
  introduction: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateEditorEn, OVERVIEW_MESSAGE.INTRODUCTION_EN)
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
  remark: z.object({
    descriptionTh: z
      .string()
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateTextEn, OVERVIEW_MESSAGE.REMARK_EN)
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  }),
});
